module.exports = __webpack_public_path__ + "static/praj-648cf9c4913404b8e3c4530f3fb5fcc4.png";